import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import {
  ACCESS_NOTICE_BUTTON_LABEL,
  ACCESS_NOTICE_TITLE,
} from "../utils/annotationSheetAccessNotice";

const AnnotationSheetAccessDialog = ({ notice, onAcknowledge }) => {
  if (!notice) return null;

  return (
    <Dialog
      open
      onClose={() => {}}
      disableEscapeKeyDown
      aria-labelledby="annotation-access-dialog-title"
      aria-describedby="annotation-access-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          overflow: "hidden",
          mx: 2,
        },
      }}
    >
      <DialogTitle
        id="annotation-access-dialog-title"
        sx={{ px: { xs: 2.5, sm: 3 }, pt: 2.5, pb: 1.25 }}
      >
        <Box display="flex" alignItems="flex-start" gap={1.5}>
          <WarningIcon color="warning" sx={{ fontSize: "28px", mt: "1px", flexShrink: 0 }} />
          <Box sx={{ minWidth: 0 }}>
            <Typography
              component="div"
              sx={{ fontSize: "18px", fontWeight: 700, lineHeight: 1.35 }}
            >
              {ACCESS_NOTICE_TITLE.english}
            </Typography>
            <Typography
              component="div"
              sx={{ color: "#444", fontSize: "18px", fontWeight: 700, lineHeight: 1.35, mt: 0.25 }}
            >
              {ACCESS_NOTICE_TITLE.chinese}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{ px: { xs: 2.5, sm: 3 } }}
        style={{ paddingTop: "4px", paddingBottom: "4px" }}
      >
        <DialogContentText
          id="annotation-access-dialog-description"
          component="div"
          sx={{ m: 0, minWidth: 0 }}
        >
          <Typography
            component="div"
            sx={{ color: "#333", fontSize: "17px", lineHeight: 1.5, overflowWrap: "anywhere" }}
          >
            {notice.english}
          </Typography>
          <Typography
            component="div"
            sx={{ color: "#333", fontSize: "17px", lineHeight: 1.5, mt: 1, overflowWrap: "anywhere" }}
          >
            {notice.chinese}
          </Typography>
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: { xs: 2.5, sm: 3 }, pb: 2, pt: 1.5 }}>
        <Button
          onClick={onAcknowledge}
          variant="contained"
          autoFocus
          sx={{
            backgroundColor: "#000",
            borderRadius: "8px",
            fontWeight: 600,
            minWidth: "112px",
            textTransform: "none",
            "&:hover": { backgroundColor: "#222" },
          }}
        >
          {ACCESS_NOTICE_BUTTON_LABEL}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnnotationSheetAccessDialog;
